module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--learn@3x-b08d631893577a5a6703f3e124b65da8.jpg";